import { render, staticRenderFns } from "./TabPrecificacaoHeader.vue?vue&type=template&id=69ba9b5a&"
import script from "./TabPrecificacaoHeader.vue?vue&type=script&lang=js&"
export * from "./TabPrecificacaoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports